import api from "@/services/api.service";
import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { EventCategory } from "./types";

export const actions: ActionTree<any, RootState> = {
    async fetchEventCategoriesTree({ commit }) {
        const eventCategoriesTree = await api.fetchEventOutcomeTree();
        commit("setEventCategoriesTree", eventCategoriesTree.data);
    },
    async fetchEventCategoriesList({ commit }) {
        const eventCategoriesList = await api.fetchEventOutcomesForUser();
        commit("setEventCategoriesList", eventCategoriesList.data);
    },
    async addEventCategory({ dispatch }, eventCategory: EventCategory) {
        await api.createEventOutcome(eventCategory);
        await dispatch("fetchEventCategoriesList");
    },
    async updateEventCategory({ dispatch }, eventCategory: EventCategory) {
        await api.updateEventOutcome(eventCategory);
        await dispatch("fetchEventCategoriesList");
    },
    async deleteEventCategory({ dispatch }, eventCategory: EventCategory) {
        await api.deleteEventOutcome(eventCategory);
        await dispatch("fetchEventCategoriesList");
    }
};